export const MIDDLE_FILE_NAME = '_EY_Canvas_Oversight_Reconciliation_Data_';
export const accountKeys = {
	status: 'status',
	primaryTeamAccountName: 'primaryTeamAccountName',
	componentTeamAccountName: 'componentTeamAccountName',
	pspIndexTitle: 'pspIndexes',
	designation: 'designation',
	c: 'c',
	eo: 'eo',
	mv: 'mv',
	ro: 'ro',
	pd: 'pd',
	comment: 'comment'
};

export const riskKeys = {
	status: 'status',
	primaryTeamRiskName: 'primaryTeamRiskName',
	componentTeamRiskName: 'componentTeamRiskName',
	riskDesignation: 'riskDesignation',
	accountsRelatedToRisk: 'accountsRelatedToRisk',
	c: 'c',
	eo: 'eo',
	mv: 'mv',
	ro: 'ro',
	pd: 'pd',
	comment: 'comment'
};

export const assertionsValues = {
	c: 'C',
	eo: 'E/O',
	mv: 'M/V',
	ro: 'R&O',
	pd: 'P&D'
};

export const greySolid = {
	type: 'pattern',
	pattern: 'solid',
	fgColor: {argb: 'FF808080'}
};
